import React, { createContext, useContext, useEffect, useState } from 'react';
import { API_URL } from '../config/env';

type Settings = {
  ministryName: string;
  email: string;
  phone: string;
  description: string;
  description_en: string;
  logoUrl?: string | null;
};



const SettingsContext = createContext<{
  settings: Settings | null;
  refresh: () => Promise<void>;
}>({ settings: null, refresh: async () => {} });

export const SettingsProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [settings, setSettings] = useState<Settings | null>(null);

  const load = async () => {
    try {
      const res = await fetch(`${API_URL}/settings`);
      if (!res.ok) throw new Error('Failed to load settings');
      const data = await res.json();
      setSettings(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => { load(); }, []);

  return <SettingsContext.Provider value={{settings, refresh: load}}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
